/* ============
 * Panoramas Module
 * ============
 */

import actions from './actions';
import mutations from './mutations';
import state from './state';

export default {
  namespaced: true,
  actions,
  getters: {
    panoramas(vuexState) {
      const panoramasCopy = [...vuexState.panoramas];
      return panoramasCopy.sort((a, b) => a.weight - b.weight);
    }
  },
  mutations,
  state,
};
